import React from 'react';
import './InternalHero.css';
import './ProductInsurance.css';
import Layout from '../PageLayout/Layout';
import { Link } from 'react-router-dom';
import DemoButton from '../shared/DemoButton';
import HeroWorkQueue from '../shared/HeroWorkQueue';

export default function InternalHero() {
  return (
    <>
      {/* Mobile — unchanged */}
      <section className="internal-hero-section pi-mobile">
        <Layout>
          <div className="internal-hero-container">
            <div className="internal-hero-badge mb-6">
              <img src="/icons/brain.svg" alt="brain Icon" />
              <span className="badge-text">Compliance-Grade Enterprise AI Platform</span>
            </div>

            <h1 className="internal-hero-heading">
              The Trusted AI Brain for Your Enterprise.
            </h1>

            <p className="internal-hero-subtext">
              Secure, compliant, and deeply integrated – Highwatch unifies your knowledge, automates workflows, and delivers instant, accurate answers across every system.
            </p>

            <div className="internal-hero-buttons">
              <Link className="internal-primary-button" to="/Contact">
                Shape the Future of Enterprise Intelligence <span className="cta-arrow" aria-hidden="true">→</span>
              </Link>
            </div>
          </div>
        </Layout>
      </section>

      {/* Desktop — Product Intelligence */}
      <section className="pi-intel-desktop pi-hero">
        <div className="pi-hero__grid" />
        <div className="pi-hero__content">
          <div className="pi-hero__badge">
            <span className="pi-hero__badge-dot" />
            COMPLIANCE-GRADE ENTERPRISE AI PLATFORM
          </div>
          <h1>The Trusted AI Brain for Your Enterprise.</h1>
          <p className="pi-hero__sub">
            Secure, compliant, and deeply integrated — Highwatch unifies your knowledge,
            automates workflows, and delivers instant, accurate answers across every system.
          </p>
          <div className="pi-hero__actions">
            <DemoButton />
            <a className="pi-btn pi-btn--ghost" href="#pi-intel-features">
              Learn How It Works →
            </a>
          </div>
          <p className="pi-hero__fine">
            No credit card required · Built for SOC 2 / GDPR-ready environments
          </p>
        </div>
        <HeroWorkQueue src="/images/My Work Queue 2.svg" />
      </section>

      {/* Desktop — Product Insurance */}
      <section className="pi-desktop pi-hero">
        <div className="pi-hero__grid" />
        <div className="pi-hero__content">
          <div className="pi-hero__badge">
            <span className="pi-hero__badge-dot" />
            BUILT FOR REGULATED INSURANCE ORGANIZATIONS
          </div>
          <h1>
            The intelligence infrastructure
            <br />
            <span>for insurance underwriting and claims</span>
          </h1>
          <p className="pi-hero__sub">
            Highwatch unifies submissions, risk, and decisions into a single intelligence layer —
            with full explainability and audit trails built in from day one.
          </p>
          <div className="pi-hero__actions">
            <DemoButton />
            <a className="pi-btn pi-btn--ghost" href="#pi-submission">
              Learn How It Works →
            </a>
          </div>
          <p className="pi-hero__fine">
            No credit card required · Built for SOC 2 / GDPR-ready environments
          </p>
        </div>
        <HeroWorkQueue />
      </section>
    </>
  );
}
